import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MonitorSmartphone, Wrench, LineChart, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    n: "01",
    icon: MonitorSmartphone,
    title: "Creazione Sito",
    tag: "Una tantum",
    desc: "Design editoriale su misura, codice pulito e veloce. Il tuo sito pronto in poche settimane.",
    to: "/creazione-siti-web-novara",
  },
  {
    n: "02",
    icon: Wrench,
    title: "Gestione Sito",
    tag: "Abbonamento mensile",
    desc: "Hosting, domini, backup giornalieri, sicurezza e aggiornamenti contenuti. Zero pensieri tecnici.",
    to: "/gestione-siti-web",
  },
  {
    n: "03",
    icon: LineChart,
    title: "Gestione SEO",
    tag: "Abbonamento mensile",
    desc: "Audit mensili, articoli ottimizzati e report trasparenti. Scala i motori di ricerca, mese dopo mese.",
    to: "/seo-novara",
  },
];

export default function Services() {
  return (
    <section id="servizi" data-testid="services-section" className="py-24 lg:py-32 bg-white border-y border-black/5">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <p className="mono-label text-[#E05638] mb-6">02 // Servizi</p>
            <h2 className="font-display font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl max-w-2xl">
              Tre pilastri per la tua presenza digitale
            </h2>
          </div>
          <p className="text-neutral-600 max-w-sm text-base leading-relaxed">
            Dalla creazione iniziale alla crescita continua: tutto sotto lo stesso tetto.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <Link key={s.n} to={s.to} data-testid={`service-link-${s.n}`} className="block">
              <motion.div
                data-testid={`service-card-${s.n}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: i * 0.12, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                whileHover={{ y: -8 }}
                className="group relative h-full bg-[#FAF8F5] border border-black/10 rounded-2xl p-8 flex flex-col min-h-[320px] hover:border-[#111111] transition-colors duration-300"
              >
                <div className="flex items-start justify-between">
                  <span className="w-12 h-12 rounded-xl bg-[#111111] text-white grid place-items-center group-hover:bg-[#E05638] transition-colors duration-300">
                    <s.icon size={22} />
                  </span>
                  <span className="font-display font-extrabold text-4xl text-black/10 group-hover:text-[#E05638]/30 transition-colors duration-300">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-display font-bold text-xl sm:text-2xl mt-8">{s.title}</h3>
                <p className="mono-label text-[#E05638] mt-2">{s.tag}</p>
                <p className="text-neutral-600 text-sm leading-relaxed mt-4 flex-1">{s.desc}</p>
                <ArrowUpRight
                  size={20}
                  className="mt-6 text-neutral-400 group-hover:text-[#E05638] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300"
                />
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
